import { useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useHistory } from "react-router-dom";
import { usePunditUserContext } from "@circle-react/contexts";
import { isPublicStream } from "@circle-react/helpers/liveStreamRoomHelpers";
import { liveStreamPaths, userPaths } from "@circle-react/helpers/urlHelpers";
import { useLiveStreamsFeatureFlags } from "@circle-react/hooks/useLiveStreamsFeatureFlags";
import { useRoom } from "./useRoom";

export const useLiveStreamsChecksRedirect = () => {
  const { isLoading: isLoadingFlags } = useLiveStreamsFeatureFlags();
  const {
    currentCommunityMember,
    currentUser,
    isLoading: isLoadingPundit,
  } = usePunditUserContext();
  const history = useHistory();
  const room = useRoom();
  const isLoading = isLoadingFlags || isLoadingPundit;

  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (room && isPublicStream(room) && !currentCommunityMember) {
      // Redirect to public room
      history.push(liveStreamPaths.publicRoom({ roomSlug: room.slug }));
    } else if (!currentUser) {
      // Redirect to login
      window.location.href = userPaths.signIn({
        params: {
          post_login_redirect: window.location.href,
        },
      });
    } else if (
      room &&
      isMobile &&
      window.location.pathname !==
        liveStreamPaths.mobileRoom({ roomSlug: room.slug })
    ) {
      history.push(liveStreamPaths.mobileRoom({ roomSlug: room.slug }));
    }
  }, [currentCommunityMember, currentUser, history, isLoading, room]);
};
